// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "fa64bc5";
